import React from 'react';
import { BaasicInput, BaasicDropdown, BaasicCheckbox, Loader, BaasicButton } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';
import { observer } from 'mobx-react';

const MarkAsShippedBulkTemplate = ({ markAsShippedBulkViewStore, t }) => {
	const { form, loading, onExternalCallback, modalParams } = markAsShippedBulkViewStore;
	if (loading) return <Loader />;
	return (
		<form className="ReactModal__form" onSubmit={form.onSubmit}>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('MARKASSHIPPEDBULKFORM.TITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				{modalParams.isLtl ? (
					<LtlOrderElements form={form} onExternalCallback={onExternalCallback} t={t} />
				) : (
					<NonLtlOrderElements form={form} onExternalCallback={onExternalCallback} t={t} />
				)}

				{form.error != null && <p className="type--color--warning">{translate(form.error)}</p>}
			</div>
			<div className="ReactModal__footer">
				<BaasicButton
					className="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
					type="submit"
					label="SAVE"
				/>
			</div>
		</form>
	);
};

const NonLtlOrderElements = observer(({ form, onExternalCallback, t }) => {
	return (
		<React.Fragment>
			<div className="table--mark-as-shipped">
				<div className="table--mark-as-shipped__header">
					<div>{t('MARKASSHIPPEDBULKFORM.FO')}</div>
					<div>{t('MARKASSHIPPEDBULKFORM.MPO')}</div>
					<div>{t('MARKASSHIPPEDBULKFORM.EXTERNALSHIPMENT')}</div>
					<div>
						{t('MARKASSHIPPEDBULKFORM.TRACKINGNUMBER')}
						<span className="type--color--warning">*</span>
					</div>
					<div>
						{t('MARKASSHIPPEDBULKFORM.SHIPPINGCOST')}
						<span className="type--color--warning">*</span>
					</div>
					<div>{t('MARKASSHIPPEDBULKFORM.SURPLUSCHARGE')}</div>
					<div>
						{t('MARKASSHIPPEDBULKFORM.WAREHOUSE')}
						<span className="type--color--warning">*</span>
					</div>
					<div>
						{t('MARKASSHIPPEDBULKFORM.CARRIERSERVICE')}
						<span className="type--color--warning">*</span>
					</div>
				</div>
			</div>

			<div className="table--mark-as-shipped__body__wrapper">
				{form.$('fulfillmentOrders').map(field => {
					return (
						<div className="table--mark-as-shipped__body" key={field.id}>
							<span className="type--wgt--bold">{field.$('fulfillmentOrderId').value}</span>
							<span>{field.$('orderNumber').value}</span>
							<div className="align--h--center">
								<div className="display--ib">
									<BaasicCheckbox
										field={field.$('externalShipment')}
										onChangeCallback={evt => onExternalCallback(evt, field)}
										className="input--check input--check--no-label"
									/>
								</div>
							</div>
							<BaasicInput noSpc disabled={field.$('externalShipment').value} field={field.$('trackingNumber')} />
							<BaasicInput noSpc field={field.$('shippingCost')} disabled={field.$('externalShipment').value} />
							<BaasicInput
								noSpc
								field={field.$('shippingCostSurcharge')}
								disabled={field.$('externalShipment').value}
							/>
							<BaasicDropdown dropdownStore={field.warehouseDropdownStore} showLabel={false} />
							<BaasicDropdown dropdownStore={field.carrierServiceDropdownStore} showLabel={false} />
						</div>
					);
				})}
			</div>
		</React.Fragment>
	);
});

const LtlOrderElements = observer(({ form, onExternalCallback, t }) => {
	return (
		<React.Fragment>
			<div className="table--mark-as-shipped">
				<div className="table--mark-as-shipped__header table--mark-as-shipped__header--ltl">
					<div>{t('MARKASSHIPPEDBULKFORM.FO')}</div>
					<div>{t('MARKASSHIPPEDBULKFORM.MPO')}</div>
					<div>{t('MARKASSHIPPEDBULKFORM.EXTERNALSHIPMENT')}</div>
					<div>
						{t('MARKASSHIPPEDBULKFORM.TRACKINGNUMBER')}
						<span className="type--color--warning">*</span>
					</div>
					<div>
						{t('MARKASSHIPPEDBULKFORM.CARRIER')}
						<span className="type--color--warning">*</span>
					</div>
				</div>
			</div>

			<div className="table--mark-as-shipped__body__wrapper">
				{form.$('fulfillmentOrders').map(field => {
					return (
						<div className="table--mark-as-shipped__body table--mark-as-shipped__body--ltl" key={field.id}>
							<span className="type--wgt--bold">{field.$('fulfillmentOrderId').value}</span>
							<span>{field.$('orderNumber').value}</span>
							<div className="align--h--center">
								<div className="display--ib">
									<BaasicCheckbox
										field={field.$('externalShipment')}
										onChangeCallback={evt => onExternalCallback(evt, field)}
										className="input--check input--check--no-label"
									/>
								</div>
							</div>
							<BaasicInput noSpc disabled={field.$('externalShipment').value} field={field.$('trackingNumber')} />
							<BaasicDropdown dropdownStore={field.carrierDropdownStore} showLabel={false} isDisabled={field.$('externalShipment').value} />
						</div>
					);
				})}
			</div>
		</React.Fragment>
	);
});

export default defaultTemplate(MarkAsShippedBulkTemplate);
